<script setup>
const user = useUser()
const ui = useUi()
const { getFlashMessageKey } = useHelpers()

const email = ref('')
const isChoosePasswordModalOpen = ref(false)

function openChoosePasswordModal (withEmail) {
  ui.flashMessageKey = getFlashMessageKey()
  email.value = withEmail
  isChoosePasswordModalOpen.value = true
}

function closeChoosePasswordModal () {
  isChoosePasswordModalOpen.value = false
}

function handleSuccess () {
  closeChoosePasswordModal()
}
</script>

<template>
  <div class="hidden xl:block">
    <NuxtImg
      src="/images/gradient-lapiz-left.svg"
      class="fixed left-0 top-0 -z-0 h-full overflow-hidden rounded-full blur"
      alt="gradient-left" />
    <NuxtImg
      src="/images/gradient-lapiz-right.svg"
      class="fixed right-0 top-0 -z-0 h-full overflow-hidden rounded-l-full  blur"
      alt="gradient-left" />
  </div>

  <AppContainer class="pt-10 md:pt-20">
    <div class="relative flex w-full flex-col items-center md:gap-20 xl:flex-row">
      <div class="relative z-0 order-2 flex flex-col gap-10 md:w-124 xl:order-1">
        <h1 class="heading-primary text-center text-3xl font-bold md:text-7xl md:leading-[58px] xl:max-w-5xl xl:text-left xl:text-[52px]">
          Certificates for the <em>modern developer</em>
        </h1>
        <p class="text-center text-sm text-eerie-black md:text-lg xl:text-left dark:text-body-gray">
          Earn certifications that will validate your skills
          and knowledge, demonstrate your commitment,
          and enhance your job prospects and career advancement.
        </p>

        <div
          v-if="user.isGuest"
          class="flex flex-col gap-8">
          <AuthSocial
            class="w-full"
            v-bind="{ mode: 'register', flashMessageKey: getFlashMessageKey() }" />
          <div class="grid gap-4">
            <p class="text-center text-sm text-eerie-black md:text-base xl:text-left dark:text-body-gray">
              Or create an account with your email
            </p>
            <LandingSignUpForm
              v-bind="{ stacked: true }"
              @success="openChoosePasswordModal" />
          </div>
        </div>

        <div v-else>
          <a
            href="#cast-your-vote"
            class="btn-primary w-full px-10 py-4 xl:w-fit">
            Cast Your Vote
          </a>
        </div>
      </div>
      <div class="relative order-1 flex-1 md:mx-10 xl:order-2 xl:mx-0">
        <div
          class="absolute left-20 z-0 hidden size-60 rounded-full bg-[#4255FF]/60 blur-[500px] md:size-120 dark:xl:block" />
        <div
          class="absolute right-32 z-0 hidden size-60 rounded-full bg-gradient-to-tl from-dodger-shine/60 to-azure-radiance/60 blur-[500px] md:size-152 dark:hidden dark:xl:block" />
        <NuxtImg
          fetch-priority="high"
          src="/images/certification-hero.svg"
          class="relative z-50 hidden aspect-video h-auto w-full dark:block"
          :width="670"
          :height="378"
          preload
          alt="Hero Image" />
        <NuxtImg
          fetch-priority="high"
          src="/images/certification-hero-light.svg"
          class="relative z-50 aspect-video h-auto w-full dark:hidden"
          :width="670"
          :height="378"
          preload
          alt="Hero Image" />
      </div>
    </div>
  </AppContainer>

  <AuthChoosePasswordModal
    v-bind="{ isOpen: isChoosePasswordModalOpen, email }"
    @success="handleSuccess"
    @close="closeChoosePasswordModal" />
</template>
